<!-- confirm message modal definition -->

<div id="confirmModal" class="modal fade" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      @if (title !== '') {
        <div class="modal-header" >
          <h4 class="modal-title w-100 text-center" [innerHTML]="title | translate"></h4>
          <button type="button" class="ttp-btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="reset()"><span aria-hidden="true">&times;</span></button>
        </div>
      }
      <div class="modal-body">
        <div class="with-icon error">
          <i class="fa fa-question-circle"></i>
          <p [innerHTML]="translateSrc | translate"></p>
        </div>
      </div>
      <div class="modal-footer">
        <div class="row row-button-group w-100 justify-content-between flex-sm-row-reverse">
          <div class="col-12 col-md-6">
            <!-- <button id="confirmBtn" type="button" class="btn d-block w-100 btn-primary" translate>MODAL.CONFIRM</button> -->
            <button id="confirmBtn" type="button" class="btn d-block w-100 btn-nowrap btn-primary" [innerHTML]="btnYes | translate"></button>
          </div>
          <div class="col-12 col-md-5">
            <button  id="cancelBtn" type="button" class="btn d-block w-100 btn-nowrap btn-default" [innerHTML]="btnNo | translate"></button>
          </div>
        </div>
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->